import { render } from "./Carousel.vue?vue&type=template&id=28ad8576&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=28ad8576&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ad8576"]])

export default __exports__